module.exports = __webpack_public_path__ + "fonts/d56cc93.otf";